export default {
    name: "SimpleBreadcrumbs",
    props: {
      links: {
        type: Array,
        default: [],
      }
    },
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {},
    methods: {}
}
